module.exports = __webpack_public_path__ + "assets/img/translation-app-3.1cc5f2f9.png";